import React from 'react';
import HeaderCell from 'components/common/ClinicManager/TableHeaderCell';
import StickyHeader from 'components/common/StickyHeader';
import './styles.scss';

export interface IProps {
  sortProp: Nullable<string>;
  sortOrder: Nullable<string>;
  sortBy: (prop: string) => void;
  isLocationWrite: boolean;
}

const TableHeader = ({ isLocationWrite, ...props }: IProps) => {
  return (
    <StickyHeader type="thead">
      <tr styleName="table-header" data-testid="table-header">
        <HeaderCell
          {...props}
          propName="name"
          style={{ minWidth: isLocationWrite ? 225 : 285 }}
        >
          <div>
            <span>Location Name</span>
          </div>
        </HeaderCell>
        <HeaderCell
          {...props}
          propName="addressLine1"
          style={{ minWidth: isLocationWrite ? 230 : 290 }}
        >
          <div>
            <span>Location Address</span>
          </div>
        </HeaderCell>
        <HeaderCell
          {...props}
          propName="city"
          style={{ minWidth: isLocationWrite ? 120 : 170 }}
        >
          <div>
            <span>City</span>
          </div>
        </HeaderCell>
        <HeaderCell
          {...props}
          propName="district"
          style={{ minWidth: isLocationWrite ? 100 : 120 }}
        >
          <div>
            <span>State</span>
          </div>
        </HeaderCell>
        <HeaderCell
          {...props}
          propName="postalCode"
          style={{ minWidth: isLocationWrite ? 100 : 110 }}
        >
          <div>
            <span>ZIP Code</span>
          </div>
        </HeaderCell>
        <HeaderCell {...props} propName="externalRef" style={{ minWidth: 115 }}>
          <div>
            <span>PearConnect ID</span>
          </div>
        </HeaderCell>
        {isLocationWrite && (
          <HeaderCell {...props} style={{ minWidth: 200 }}>
            <div styleName="table-actions">
              <span>Actions</span>
            </div>
          </HeaderCell>
        )}
      </tr>
    </StickyHeader>
  );
};

export default TableHeader;
